export default __webpack_public_path__ + "static/rashmi-41bef68b5fcb70d96f40d03cf734bc0b.svg";